<template>
    <basic-container>
        <avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" v-model="form" :page.sync="page" @search-change="searchChange" @search-reset="searchReset" @selection-change="selectionChange" @current-change="currentChange" @size-change="sizeChange" @refresh-change="refreshChange">
            <!--  @on-load="onLoad" -->
            <template slot="menuLeft">
                <el-button size="small" icon="el-icon-collection-tag">全部标为已读
                </el-button>
            </template>
            <template slot-scope="scope" slot="menu">
                <el-button type="text" size="small" plain class="none-border">撤销
                </el-button>
                <el-button type="text" size="small" plain class="none-border">发布
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>
<script>
import { mapGetters } from "vuex";
import website from '@/config/website';
import { modelList, removeModel, deployModel } from "@/api/flow/flow";
import { flowCategory } from "@/util/flow";

export default {
    data() {
        return {
            form: {},
            selectionId: '',
            selectionList: [],
            query: {},
            loading: true,
            deployLoading: false,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            deployBox: false,
            flowBox: false,
            flowUrl: '',
            option: {
                height: 'auto',
                calcHeight: 30,
                tip: false,
                searchShow: true,
                searchMenuSpan: 6,
                border: true,
                selection: true,
                editBtn: true,
                addBtn: true,
                viewBtn: false,
                delBtn: false,
                dialogWidth: 900,
                menuWidth: 150,
                searchLabelWidth: 100,
                dialogClickModal: false,
                column: [{
                        label: '编号',
                        prop: 'id',
                    },
                    {
                        label: '工作信息标题',
                        prop: 'modelKey',
                        search: true,
                        width: 150,
                    },
                    {
                        label: '消息类型',
                        prop: 'name',
                        width: 150,
                    },
                    {
                        label: '发布人',
                        prop: 'version',
                        search: true,
                        width: 80,
                    },
                    {
                        label: '审核人',
                        prop: 'created',
                        width: 165,
                    },
                    {
                        label: '审核状态',
                        prop: 'lastUpdated',
                        width: 165,
                    },
                    {
                        label: '优先级',
                        prop: 'lastUpdated',
                        width: 165,
                    },
                    {
                        label: '发布时间',
                        prop: 'lastUpdated',
                        width: 165,
                    },
                    {
                        label: '阅读状态',
                        prop: 'lastUpdated',
                        width: 165,
                    },
                ]
            },
            data: []
        };
    },
    watch: {
        'form.flowMode'() {
            this.$refs.form.option.column.filter(item => {
                if (item.prop === "tenantId") {
                    item.display = this.form.flowMode === 2;
                }
            });
        }
    },
    computed: {
        ...mapGetters(["permission"]),
        ids() {
            let ids = [];
            this.selectionList.forEach(ele => {
                ids.push(ele.id);
            });
            return ids.join(",");
        }
    },
    methods: {
        handleSubmit(form, done) {
            this.deployLoading = true;
            deployModel({
                modelId: this.selectionId,
                category: flowCategory(form.categoryValue),
                tenantIds: form.tenantId.join(",")
            }).then(res => {
                const data = res.data;
                if (data.success) {
                    this.$message({
                        type: "success",
                        message: data.msg
                    });
                    done();
                    this.$refs.form.resetForm();
                    this.deployBox = false;
                    this.deployLoading = false;
                } else {
                    done();
                    this.deployLoading = false;
                    this.$message({
                        type: "warn",
                        message: data.msg
                    });
                }
            })
        },
        searchReset() {
            this.query = {};
            this.onLoad(this.page);
        },
        searchChange(params, done) {
            this.query = params;
            this.page.currentPage = 1;
            this.onLoad(this.page, params);
            done();
        },
        selectionChange(list) {
            this.selectionList = list;
        },
        selectionClear() {
            this.selectionList = [];
            this.$refs.crud.toggleSelection();
        },
        handleDelete() {
            if (this.selectionList.length === 0) {
                this.$message.warning("请选择至少一条数据");
                return;
            }
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return removeModel(this.ids);
                })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                    this.$refs.crud.toggleSelection();
                    this.onLoad(this.page);
                });
        },
        handleCreate() {
            this.flowUrl = `${website.flowDesignUrl}/index.html`;
            this.flowBox = true;
        },
        handleUpdate(row) {
            this.flowUrl = `${website.flowDesignUrl}/index.html#/editor/${row.id}`;
            this.flowBox = true;
        },
        handleDeploy(row) {
            this.deployBox = true;
            this.selectionId = row.id;
        },
        handleDoDeploy() {
            this.$refs.form.submit();
        },
        handleDownload(row) {
            window.open(`${website.flowDesignUrl}/app/rest/models/${row.id}/bpmn20`);
        },
        handleSlotDelete(row) {
            this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                .then(() => {
                    return removeModel(row.id);
                })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                    this.$refs.crud.toggleSelection();
                    this.onLoad(this.page);
                });
        },
        handleRefresh() {
            this.flowBox = false;
            this.onLoad(this.page);
        },
        currentChange(currentPage) {
            this.page.currentPage = currentPage;
        },
        sizeChange(pageSize) {
            this.page.pageSize = pageSize;
        },
        refreshChange() {
            this.onLoad(this.page, this.query);
        },
        onLoad(page, params = {}) {
            this.loading = true;
            modelList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
                this.selectionClear();
            });
        }
    }
};

</script>
<style>
.none-border {
    border: 0;
    background-color: transparent !important;
}

</style>
